import { render, staticRenderFns } from "./BriefsTabIcon.vue?vue&type=template&id=ba2bbadc"
import script from "./BriefsTabIcon.vue?vue&type=script&lang=js"
export * from "./BriefsTabIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports